import { SxProps } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  sx?: SxProps;
};

export const DetailsViewWrapper: React.FC<Props> = props => {
  return (
    <Grid container spacing={2} sx={props.sx}>
      {props.children}
    </Grid>
  );
};
